const scheduledServicesByUserAndDayModal = {
  titleScheduled: "Servicios Programados",
  titleCompleted: "Servicios Completados",
  serialNumber: "Número de Serie",
  place: "Lugar",
  scheduledDate: "Fecha Programada",
  accountable: "Responsable",
  confirm: '¿Realmente quieres eliminar este servicio programado?',
  title: 'ELIMINAR SERVICIO PROGRAMADO'
};

export default scheduledServicesByUserAndDayModal;
